import {
  makeKolInfo1,
  makeKolInfo2,
  makeKolInfo3,
  makeKolInfo4,
  makeKolInfo5,
} from '@/constants/mock-data/kol-info'
import { SupportedLanguages } from '@/i18n/config'
import { RelatedKolType } from '@/store/kol-detail'
import { RelatedKol } from '@/types/api/kols'

type MentionedKolMaker = (locale?: SupportedLanguages) => RelatedKol

const makeMockMentionedKol1: MentionedKolMaker = (locale) => {
  const kolInfo = makeKolInfo1(locale)

  return {
    uuid: kolInfo.id,
    name: kolInfo.name,
    follower: kolInfo.follower,
    kolType: RelatedKolType.Person,
    rank: 1,
    mentionCount: 4,
    platformName: kolInfo.id,
    etlAt: null,
  }
}

const makeMockMentionedKol2: MentionedKolMaker = (locale) => {
  const kolInfo = makeKolInfo2(locale)

  return {
    uuid: kolInfo.id,
    name: kolInfo.name,
    follower: kolInfo.follower,
    kolType: RelatedKolType.Person,
    rank: 2,
    mentionCount: 4,
    platformName: kolInfo.id,
    etlAt: null,
  }
}

const makeMockMentionedKol3: MentionedKolMaker = (locale) => {
  const kolInfo = makeKolInfo3(locale)

  return {
    uuid: kolInfo.id,
    name: kolInfo.name,
    follower: kolInfo.follower,
    kolType: RelatedKolType.Person,
    rank: 3,
    mentionCount: 4,
    platformName: kolInfo.id,
    etlAt: null,
  }
}

const makeMockMentionedKol4: MentionedKolMaker = (locale) => {
  const kolInfo = makeKolInfo4(locale)

  return {
    uuid: kolInfo.id,
    name: kolInfo.name,
    follower: kolInfo.follower,
    kolType: RelatedKolType.Person,
    rank: 4,
    mentionCount: 4,
    platformName: kolInfo.id,
    etlAt: null,
  }
}

const makeMockMentionedKol5: MentionedKolMaker = (locale) => {
  const kolInfo = makeKolInfo5(locale)

  return {
    uuid: kolInfo.id,
    name: kolInfo.name,
    follower: kolInfo.follower,
    kolType: RelatedKolType.Person,
    rank: 5,
    mentionCount: 4,
    platformName: kolInfo.id,
    etlAt: null,
  }
}

const mockMentionedKol1 = makeMockMentionedKol1()
const mockMentionedKol2 = makeMockMentionedKol2()
const mockMentionedKol3 = makeMockMentionedKol3()
const mockMentionedKol4 = makeMockMentionedKol4()
const mockMentionedKol5 = makeMockMentionedKol5()

const mockMentionedKolList = [
  mockMentionedKol1,
  mockMentionedKol2,
  mockMentionedKol3,
  mockMentionedKol4,
  mockMentionedKol5,
]

export { mockMentionedKolList }
